(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('FileStoreDeleteController',FileStoreDeleteController);

    FileStoreDeleteController.$inject = ['$uibModalInstance', 'entity', 'FileStore'];

    function FileStoreDeleteController($uibModalInstance, entity, FileStore) {
        var vm = this;

        vm.fileStore = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FileStore.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
